import { render, staticRenderFns } from "./test.vue?vue&type=template&id=1d658ce7&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyHeroSlider: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EmptyHeroSlider/index.vue').default,Section: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Section/index.vue').default,SectionPartners: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionPartners/index.vue').default})
